import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 0,
  class: "impersonating_header"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createBlock(_component_Menubar, null, {
    start: _withCtx(() => [
      _createVNode(_component_Button, {
        text: "",
        icon: "pi pi-bars",
        severity: "secondary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleMenu')))
      }),
      (_ctx.logoDark && _ctx.themeStore.getTheme === 'dark')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.logoDark,
            alt: "logo"
          }, null, 8, _hoisted_1))
        : (_ctx.logoLight && _ctx.themeStore.getTheme === 'light')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.logoLight,
              alt: "logo"
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('app.name')), 1))
    ]),
    end: _withCtx(() => [
      (_ctx.isImpersonating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Button, {
              onClick: _ctx.impersonateRollback,
              icon: "pi pi-fw pi-sign-in",
              label: _ctx.$t('global_components.page_with_left_menu.view.impersonate_rollback_button'),
              size: "small",
              severity: "secondary"
            }, null, 8, ["onClick", "label"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}